import { EventHandler, createElement, formatUnit } from '@syncfusion/ej2-base';
import { Month } from './month';
import { TimelineEvent } from '../event-renderer/timeline-view';
import { TimelineHeaderRow } from './timeline-header-row';
import * as util from '../base/util';
import * as event from '../base/constant';
import * as cls from '../base/css-constant';
/**
 * timeline month view
 */
export class TimelineMonth extends Month {
    constructor(parent) {
        super(parent);
        this.viewClass = 'e-timeline-month-view';
        this.isInverseTableSelect = true;
        this.appointment = null;
    }
    getModuleName() {
        return 'timelineMonth';
    }
    onDataReady() {
        this.appointment = new TimelineEvent(this.parent, 'day');
        this.appointment.renderAppointments();
        this.parent.notify(event.eventsLoaded, {});
    }
    getLeftPanelElement() {
        return this.element.querySelector('.' + cls.RESOURCE_COLUMN_WRAP_CLASS);
    }
    scrollTopPanel(target) {
        super.scrollTopPanel(target);
        this.scrollHeaderLabels(target);
    }
    setContentHeight(content, leftPanelElement, height) {
        if (leftPanelElement) {
            leftPanelElement.style.height = formatUnit(height - this.getScrollXIndent(content));
        }
        content.style.height = formatUnit(height);
    }
    getDateSlots(renderDates, workDays) {
        const dateSlots = [];
        for (const col of renderDates) {
            const classList = [cls.HEADER_CELLS_CLASS];
            if (this.isCurrentDate(col)) {
                classList.push(cls.CURRENT_DAY_CLASS);
            }
            dateSlots.push({ date: col, type: 'dateHeader', className: classList, colSpan: 1, workDays: workDays });
        }
        return dateSlots;
    }
    renderLeftIndent(tr) {
        if (this.parent.activeViewOptions.group.resources.length > 0 && !this.parent.uiStateValues.isGroupAdaptive) {
            this.parent.resourceBase.renderResourceHeaderIndent(tr);
        }
    }
    renderContent() {
        const contentTr = createElement('tr');
        if (this.parent.activeViewOptions.group.resources.length > 0 && !this.parent.uiStateValues.isGroupAdaptive) {
            const resTd = createElement('td');
            resTd.appendChild(this.parent.resourceBase.createResourceColumn());
            contentTr.appendChild(resTd);
        }
        const contentTd = createElement('td');
        this.element.querySelector('tbody').appendChild(contentTr);
        const wrap = createElement('div', { className: cls.CONTENT_WRAP_CLASS });
        wrap.appendChild(this.renderContentArea());
        wrap.appendChild(this.createEventTable(this.getRowCount()));
        this.collapseRows(wrap);
        EventHandler.add(wrap, 'scroll', this.onContentScroll, this);
        contentTd.appendChild(wrap);
        if (this.parent.virtualScrollModule) {
            this.parent.virtualScrollModule.renderVirtualTrack(wrap);
        }
        contentTr.appendChild(contentTd);
    }
    getRowCount() {
        if (this.parent.activeViewOptions.group.resources.length > 0 && !this.parent.uiStateValues.isGroupAdaptive) {
            return this.parent.resourceBase.renderedResources.length;
        }
        return 1;
    }
    getContentSlots() {
        const slotDatas = [];
        for (let row = 0; row < this.getRowCount(); row++) {
            for (const data of this.colLevels[this.colLevels.length - 1]) {
                data.className = [cls.WORK_CELLS_CLASS];
                if (this.parent.activeViewOptions.group.resources.length > 0 && !this.parent.uiStateValues.isGroupAdaptive) {
                    const resLevel = this.parent.resourceBase.renderedResources[parseInt(row.toString(), 10)];
                    data.workDays = resLevel.resourceData[resLevel.resource.workDaysField] || this.parent.workDays;
                    data.className = data.className.concat(resLevel.className);
                    data.groupIndex = resLevel.groupIndex;
                    data.groupOrder = resLevel.groupOrder;
                }
                const slotData = {
                    date: new Date(+data.date), colSpan: data.colSpan, groupIndex: data.groupIndex, workDays: data.workDays,
                    type: 'monthCells', className: data.className
                };
                if (!slotDatas[parseInt(row.toString(), 10)]) {
                    slotDatas[parseInt(row.toString(), 10)] = [];
                }
                slotDatas[parseInt(row.toString(), 10)].push(slotData);
            }
        }
        return slotDatas;
    }
    updateClassList(data) {
        if (!this.parent.isMinMaxDate(data.date)) {
            data.className.push(cls.DISABLE_DATES);
        }
    }
    unWireEvents() {
        EventHandler.remove(this.getContentAreaElement(), 'scroll', this.onContentScroll);
    }
    getMonthStart(currentDate) {
        const monthStart = this.parent.calendarUtil.firstDateOfMonth(util.resetTime(currentDate));
        return new Date(monthStart.getFullYear(), monthStart.getMonth(), monthStart.getDate());
    }
    getMonthEnd(currentDate) {
        const monthStart = this.parent.calendarUtil.firstDateOfMonth(util.resetTime(currentDate));
        return this.parent.calendarUtil.lastDateOfMonth(util.addMonths(new Date(+monthStart), this.parent.activeViewOptions.interval - 1));
    }
    generateColumnLevels() {
        let colLevels = [];
        const level = this.getDateSlots(this.renderDates, this.parent.activeViewOptions.workDays);
        colLevels.push(level);
        if (this.parent.activeViewOptions.group.resources.length > 0) {
            this.parent.resourceBase.generateResourceLevels(level, !this.parent.uiStateValues.isGroupAdaptive);
        }
        const hourSlots = [];
        if (this.parent.activeViewOptions.headerRows.length > 0) {
            const renderGn = new TimelineHeaderRow(this.parent, this.renderDates);
            colLevels = renderGn.generateColumnLevels(level, hourSlots);
        }
        this.colLevels = colLevels;
        return colLevels;
    }
    getAdjustedDate(startTime) {
        const timeSlots = this.colLevels[this.colLevels.length - 1];
        for (let i = 0; i < timeSlots.length; i++) {
            if (timeSlots[parseInt(i.toString(), 10)].date.getTime() > startTime.getTime()) {
                return timeSlots[i - 1].date;
            }
        }
        return null;
    }
    destroy() {
        if (!this.parent || this.parent && this.parent.isDestroyed) {
            return;
        }
        if (this.element) {
            const contentScrollableEle = this.element.querySelector('.' + cls.CONTENT_WRAP_CLASS);
            if (contentScrollableEle) {
                EventHandler.remove(contentScrollableEle, 'scroll', this.onContentScroll);
            }
        }
        if (this.appointment) {
            this.appointment.destroy();
            this.appointment = null;
        }
        super.destroy();
    }
}
